var map = {
	"./": 2942,
	"./bianchi_1.png": 5536,
	"./bianchi_2.png": 6972,
	"./bianchi_3.png": 4551,
	"./bianchi_4.png": 7446,
	"./bianchi_5.png": 8403,
	"./bianchi_6.png": 1701,
	"./bianco.jpg": 5183,
	"./default.png": 4162,
	"./image.png": 4490,
	"./image_1.jpg": 7633,
	"./image_2.jpg": 148,
	"./image_3.jpeg": 4620,
	"./image_4.jpeg": 1576,
	"./image_5.jpeg": 9966,
	"./index": 2942,
	"./index.js": 2942,
	"./liquori_1.png": 3838,
	"./liquori_2.png": 349,
	"./liquori_3.png": 1503,
	"./liquori_4.png": 3208,
	"./logo.png": 9539,
	"./menabo_1.jpg": 6148,
	"./menabo_1_m.jpg": 5530,
	"./menabo_2.jpg": 1569,
	"./menabo_2_m.jpg": 6984,
	"./menabo_3.jpg": 7246,
	"./menabo_3_m.jpg": 9000,
	"./menabo_4.jpg": 1855,
	"./menabo_4_m.jpg": 5658,
	"./olio_1.png": 4729,
	"./olio_2.png": 8137,
	"./olio_3.png": 9532,
	"./rosati_1.png": 8445,
	"./rosato.jpg": 9129,
	"./rossi_1.png": 8558,
	"./rossi_2.png": 5460,
	"./rossi_3.png": 7614,
	"./rossi_4.png": 107,
	"./rosso.jpg": 262,
	"./spumante.jpg": 7080,
	"./spumanti_1.png": 4633
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4852;